import {FlowNodeData, FlowNodeTypes, SettingParamTypes} from "@/types/node";
import {Node} from "@xyflow/react";

export const transferNodeBlueprint: Partial<Node<FlowNodeData>> = {
  type: FlowNodeTypes.TRANSFER,
  data: {
    type: FlowNodeTypes.TRANSFER,
    settingsTitle: "Call Transfer",
    description: "Transfer the call to a human agent",
    onChange: () => {
      console.log("Transfer node changed");
    },
    settings: [
      {
        title: "General",
        expandedSetting: true,
        params: [
          {
            hidden: true,
            type: SettingParamTypes.VALUE,
            key: "action",
            value: {},
          },
        ],
      },
    ],
  },
  position: {x: 0, y: 0},
};
